"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const systemComponents_1 = require("@/store/ducks/systemComponents");
const selectors_1 = require("@/store/ducks/systemComponents/selectors");
const listComponentsUseCase_1 = require("@/useCases/components/listComponentsUseCase");
const associateSystemComponentsUseCase_1 = __importDefault(require("@/useCases/systemComponents/associateSystemComponentsUseCase"));
const formik_1 = require("formik");
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const yup = __importStar(require("yup"));
const index_view_1 = __importDefault(require("./index.view"));
function AssociateSystemComponentsTable() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { systemId } = (0, react_router_dom_1.useParams)();
    react_1.default.useEffect(() => {
        (0, listComponentsUseCase_1.listComponents)()(dispatch);
    }, []);
    const systemComponents = (0, react_redux_1.useSelector)(selectors_1.systemComponentsSelector);
    const autoCompleteOptions = (0, react_redux_1.useSelector)(selectors_1.autoCompleteOptionsSelector);
    const initialValues = react_1.default.useMemo(() => ({
        systemComponents: [
            ...systemComponents,
            {
                id: "-",
                unit: "-",
                order: 0,
                name: "Select Component",
                range: { lowLimitValue: 0, highLimitValue: 0 },
            },
        ],
    }), [systemComponents]);
    yup.addMethod(yup.array, "uniqueArray", function (mapper = (component) => component, message = "") {
        return this.test("uniqueArray", message, function (list) {
            const uniqueValues = new Set(list?.map(mapper));
            const duplicateItensPositions = [];
            const duplicateIds = list
                ?.map((item) => item?.id)
                .filter((item, index, ids) => ids.indexOf(item) !== index);
            list?.forEach((component) => {
                if (duplicateIds?.includes(component?.id)) {
                    duplicateItensPositions.push(list.indexOf(component));
                }
            });
            const duplicateComponentsErrors = list
                ?.filter((component) => {
                if (component?.id && duplicateIds?.includes(component?.id)) {
                    return component;
                }
            })
                .reduce((acc, curr) => {
                const duplicateComponentIndex = list.indexOf(curr);
                acc = {
                    ...acc,
                    [`${[duplicateComponentIndex]}`]: "Duplicate Value",
                };
                return acc;
            }, {});
            if (uniqueValues?.size !== list?.length) {
                throw this.createError({
                    path: `${this.path}`,
                    message: duplicateComponentsErrors || "Duplicate Value",
                });
            }
            return true;
        });
    });
    const validationSchema = yup.object().shape({
        systemComponents: yup
            .array()
            .of(yup
            .object()
            .shape({
            order: yup.number(),
            name: yup.string().required("Required").min(1),
            id: yup.string(),
            unit: yup.string(),
        })
            .required("Required")
            .nullable())
            .uniqueArray((item) => {
            return item?.name;
        }, "Error"),
    });
    const onSubmit = react_1.default.useCallback(async (values) => {
        const filteredValues = values.systemComponents.slice(0, values.systemComponents.length - 1);
        await (0, associateSystemComponentsUseCase_1.default)(systemId, filteredValues)(dispatch);
    }, [dispatch, initialValues]);
    const onOpenRemoveAssociationModal = (componentToBeUnlinked, index) => {
        dispatch((0, systemComponents_1.setRowIndexToBeRemoved)(index));
        dispatch((0, systemComponents_1.openDeleteAssociationModal)());
        dispatch((0, systemComponents_1.seComponentToBeRemoved)(componentToBeUnlinked));
    };
    const onToggleSavePrompt = react_1.default.useCallback(() => {
        dispatch((0, systemComponents_1.onShowSavePrompt)());
    }, [dispatch, systemComponents_1.onShowSavePrompt]);
    return (react_1.default.createElement(formik_1.Formik, { onSubmit: onSubmit, initialValues: initialValues, enableReinitialize: true, validationSchema: validationSchema, validateOnChange: true, validateOnBlur: false }, (props) => {
        return (react_1.default.createElement(index_view_1.default, { onDelete: onOpenRemoveAssociationModal, selectComponentOptions: autoCompleteOptions, componentRowInputs: props.values, errors: props.errors, onToggleSavePrompt: onToggleSavePrompt }));
    }));
}
exports.default = AssociateSystemComponentsTable;
